/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { useTable, usePagination } from 'react-table'

import { fetchReport } from '../actions/fundingfeeActions'

const ReportTable = ({ reports, fetchReport, posting }) => {
  const {
    params: { action }
  } = useRouteMatch('/lgyhub/funding-fee/refunds/report/:action')

  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'fetch',
        Cell: ({ value }) => (
          <button onClick={value} disabled={posting}>
            Download
          </button>
        )
      },
      { Header: 'Name', accessor: 'groupName' },
      { Header: 'Refunds', accessor: 'recordSize' },
      { Header: 'Created on', accessor: 'createdDate' }
    ],
    [posting]
  )
  const data = useMemo(
    () =>
      reports.map(({ groupName, recordSize, createdDate }) => ({
        fetch: () => fetchReport({ action, groupName }),
        createdDate: new Date(createdDate).toString(),
        groupName,
        recordSize
      })),
    [reports, fetchReport, action]
  )

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    canNextPage,
    nextPage,
    canPreviousPage,
    previousPage,
    setPageSize,
    state: { pageSize }
  } = useTable({ columns, data, initialState: { pageIndex: 0, pageSize: 10 } }, usePagination)

  return (
    <div className='lgy-funding-fee-refund-reports-table'>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <label for='select_number_of_reports_id'>Select Number Of Reports:</label>
      <select
        id='select_number_of_reports_id'
        className='usa-width-one-fourth'
        defaultValue={pageSize}
        onChange={e => setPageSize(parseInt(e.target.value))}
      >
        {[5, 10, 25, 100, 250].map(pages => (
          <option key={pages} value={pages}>
            {pages}
          </option>
        ))}
      </select>{' '}
      reports
      <button onClick={previousPage} disabled={!canPreviousPage}>
        {'<'} Prev {pageSize}
      </button>
      <button onClick={nextPage} disabled={!canNextPage}>
        Next {pageSize} {'>'}
      </button>
    </div>
  )
}

const mapStateToProps = state => ({ posting: state.fundingFee?.posting })

export default connect(mapStateToProps, { fetchReport })(ReportTable)
